import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

export default function useGameToastMessages(tempTableId) {
    const toastMessages = useSelector((state) => state.gameTable.games[tempTableId]?.toastMessages);

    if (!toastMessages) {
        return []
    }

    return toastMessages
}
